import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

import { UploadStudyModalModule } from 'src/app/clinic-studies/upload-study-modal/upload-study-modal.module';
import { LeftNavigationComponent } from './left-navigation.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [LeftNavigationComponent],
  imports: [CommonModule, RouterModule, UploadStudyModalModule, NgbTooltipModule],
  exports: [LeftNavigationComponent, RouterModule],
  providers: [CookieService],
})
export class LeftNavigationModule {}
